<div class="admin-page">

  <div class="admin-header">
    <h1 class="admin-title">
      <mat-icon>admin_panel_settings</mat-icon>
      Admin Panel
    </h1>
    <p class="admin-subtitle">Site management and configuration</p>
  </div>

  <!-- Quick-access cards -->
  <section class="admin-section">
    <h2 class="section-heading">Management</h2>
    <div class="admin-cards">
      <div class="admin-card" *ngFor="let card of adminCards" (click)="navigate(card.route)">
        <mat-icon class="admin-card-icon">{{ card.icon }}</mat-icon>
        <div class="admin-card-body">
          <div class="admin-card-title">{{ card.title }}</div>
          <div class="admin-card-desc">{{ card.description }}</div>
        </div>
        <mat-icon class="admin-card-arrow">chevron_right</mat-icon>
      </div>
    </div>
  </section>

  <!-- Menu Visibility -->
  <section class="admin-section">
    <h2 class="section-heading">
      <mat-icon class="section-icon">visibility</mat-icon>
      Navigation Visibility
    </h2>
    <p class="section-desc">
      Toggle which menu items are shown to users. Admin items are always visible and cannot be hidden.
      Changes take effect immediately for all users.
    </p>

    <div class="menu-config-grid">

      <!-- Provider menu -->
      <div class="menu-panel">
        <div class="menu-panel-header">
          <mat-icon>engineering</mat-icon>
          <span>Provider Menu</span>
          <span class="menu-panel-role">role: provider</span>
        </div>
        <div class="menu-items-list">
          <div class="menu-item-row" *ngFor="let item of providerItems"
               [class.menu-item-locked]="item.adminRequired">
            <mat-icon class="menu-item-icon">{{ item.icon }}</mat-icon>
            <span class="menu-item-label">{{ item.label }}</span>
            <span class="menu-item-route">{{ item.routerlink }}</span>
            <mat-slide-toggle
              [checked]="isVisibleForRole('provider', item)"
              [disabled]="item.adminRequired"
              (change)="onToggle('provider', item, $event)"
              color="primary">
            </mat-slide-toggle>
            <span class="menu-item-locked-badge" *ngIf="item.adminRequired">
              <mat-icon>lock</mat-icon> Always on
            </span>
          </div>
        </div>
      </div>

      <!-- Customer menu -->
      <div class="menu-panel">
        <div class="menu-panel-header">
          <mat-icon>person</mat-icon>
          <span>Customer Menu</span>
          <span class="menu-panel-role">role: customer</span>
        </div>
        <div class="menu-items-list">
          <div class="menu-item-row" *ngFor="let item of customerItems"
               [class.menu-item-locked]="item.adminRequired">
            <mat-icon class="menu-item-icon">{{ item.icon }}</mat-icon>
            <span class="menu-item-label">{{ item.label }}</span>
            <span class="menu-item-route">{{ item.routerlink }}</span>
            <mat-slide-toggle
              [checked]="isVisibleForRole('customer', item)"
              [disabled]="item.adminRequired"
              (change)="onToggle('customer', item, $event)"
              color="primary">
            </mat-slide-toggle>
          </div>
        </div>
      </div>

    </div>
  </section>

</div>
